import { Provider } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { BrowserNavigationService } from './browser-navigation.service';
import { NativeBrowserNavigationService } from './native-browser-navigation.service';
import { WebBrowserNavigationService } from './web-browser-navigation.service';
import { InAppBrowserService } from '../in-app-browser.service';


export const browserServiceFactory = (inAppBrowser: InAppBrowserService): BrowserNavigationService => {
  return Capacitor.isNativePlatform()
    ? new NativeBrowserNavigationService(inAppBrowser)
    : new WebBrowserNavigationService()
};

export const BROWSER_NAVIGATION_SERVICE_PROVIDER: Provider = {
  provide: BrowserNavigationService,
  useFactory: browserServiceFactory,
  deps: [InAppBrowserService]
}
